import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const ALLOWED_ROLES = ["System Admin", "Admin", "Leadership"];

const PrivateLeadershipRoutes: React.FC = () => {
  const { currentUser, userRole } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  const localRole = localStorage.getItem("currentRole") || "";

  if (!ALLOWED_ROLES.includes(localRole) && !ALLOWED_ROLES.includes(userRole)) {
    return <Navigate to="/status/401" />;
  }

  return <Outlet />;
};

export default PrivateLeadershipRoutes;
